<template>
  <van-pull-refresh v-model="isRefreshing" class="home" @refresh="onRefresh">
    <van-nav-bar :title="$route.meta.title" fixed>
      <van-icon slot="right" name="records" style="margin-right: 10px;" color="#F18A2E" size="22px" @click="toEditPeople" />
      <van-icon slot="right" :info="applycount==0?'':applycount" name="user-circle-o" color="#F18A2E" size="22px" @click="toApplyList" />
    </van-nav-bar>
    <div class="home-hd">
      <section class="score">
        <div v-if="familyList && familyList.length>0">
          <div class="van-grid sy-cell_start flexwap">
            <div v-for="(item,index) in familyList" :key="index" class="sy-cell_center ibox-main" @click="queryToFamilyById(item.accountId,index)">
              <img :class="item.select?'peo-image__img headerActive':'peo-image__img'" :src="item.headUrl">
              <div :class="item.select?'describe describe-color':'describe'">{{ item.relationShip !=null && item.relationShip !='' && item.relationShip !='其他'? item.relationShip:item.name }}</div>
              <div v-if="!minus" :class="item.select? 'radio-no radio-check':'radio-no'" @click.stop="queryToFamilyById(item.accountId,index)">
                <van-icon name="success" />
              </div>
            </div>
            <div v-if="minus" class="sy-cell ibox-main">
              <img :src="addFamily" class="peo-image__img" @click="toAddFamily">
            </div>
            <div v-if="minus" class="sy-cell ibox-main">
              <img src="../../assets/images/family/del.png" class="peo-image__img" @click="minusFamily">
            </div>
            <div v-if="!minus" class="sy-cell ibox-main main-top">
              <button class="del-btn cancle-btn" @click="minus=true">取消</button>
            </div>
            <div v-if="!minus" class="sy-cell ibox-main main-top">
              <button class="del-btn" @click="beforeClose">删除</button>
            </div>
          </div>
        </div>
        <div v-if=" showFam &&familyList.length===0 ">
          <div class="report" @click="toAddFamily">
            <div class="divs">
              <div class="imgs"><img class="addfamily" :src="addFamily"></div>
              <div class="infos">添加家人，关注家人健康</div>
            </div>
          </div>
        </div>
      </section>
      <section class="sport">
        <div class="title">
          {{ $t('viewBase.a1') }}
        </div>
        <div class="content">

          <div class="item" @click="toItem('hrvIndex','hrv','hrvIndex')">
            <div class="hd">
              <i class="iconfont icon-HRV" />
              HRV心脏指数</div>
            <div class="bd">
              <div v-if="health.firstHrv.state" :class="!health.firstHrv.normal?'abnormal':''">{{ health.firstHrv.hrvIndex }}<span class="key">ms</span>
                <i v-if="!health.firstHrv.normal" class="iconfont icon-xiajiantou abnormal" />
                <span v-if="health.firstHrv.state" class="abnormal-mr" />
              </div>
              <div v-else class="key">未测量</div>
              <div v-if="health.firstHrv && health.firstHrv.state && health.firstHrv.testTime!=null && health.firstHrv.testTime !==''" class="time">
                {{ dateFormat(health.firstHrv.testTime, 'YYYY-MM-DD hh:mm') }}
              </div>
            </div>
          </div>

          <div class="item" @click="toItem('breathPause','呼吸暂停','apneaCount')">
            <div class="hd">
              <i class="iconfont icon-shuimian" />
              呼吸暂停次数</div>
            <div class="bd">
              <div v-if="health.apnea.state" :class="!health.apnea.normal?'abnormal':''">{{ health.apnea.apneaCount }}<span class="key">次</span>
                <i v-if="!health.apnea.normal" class="iconfont icon-iconset0414 abnormal" />
                <span v-if="health.apnea.normal" class="abnormal-mr" />
              </div>
              <div v-else class="key">未测量</div>
              <div v-if="health.apnea && health.apnea.state && health.apnea.testTime!=null && health.apnea.testTime !==''" class="time">
                {{ dateFormat(health.apnea.testTime, 'YYYY-MM-DD hh:mm') }}
              </div>
            </div>
          </div>

          <div class="item" @click="toItem('bp','血压','dbp&sbp')">
            <div class="hd">
              <i class="iconfont icon-xueya" />
              血压</div>
            <div class="bd">
              <div v-if="health.firstBloodPressure.state">
                <span :class="strChangeArr(health.firstBloodPressure.state2)[0]!=='正常'?'abnormal':''">{{ health.firstBloodPressure.sbp }}</span>/<span :class="strChangeArr(health.firstBloodPressure.state2)[1]!=='正常'?'abnormal':''">{{ health.firstBloodPressure.dbp }}</span><span class="key">mmHg</span>
                <i v-if="strChangeArr(health.firstBloodPressure.state2)[0]==='偏高'||strChangeArr(health.firstBloodPressure.state2)[1]==='偏高'" class="iconfont icon-iconset0414 abnormal" />
                <i v-if="strChangeArr(health.firstBloodPressure.state2)[0]==='偏低'||strChangeArr(health.firstBloodPressure.state2)[1]==='偏低'" class="iconfont icon-xiajiantou abnormal" />
                <span v-if="strChangeArr(health.firstBloodPressure.state2)[0]==='正常'&&strChangeArr(health.firstBloodPressure.state2)[1]==='正常'" class="abnormal-mr" />
              </div>
              <div v-else class="key">未测量</div>
              <div v-if="health.firstBloodPressure && health.firstBloodPressure.state && health.firstBloodPressure.testTime!=null && health.firstBloodPressure.testTime !==''" class="time">
                {{ dateFormat(health.firstBloodPressure.testTime, 'YYYY-MM-DD hh:mm') }}
              </div>
            </div>
          </div>

          <div class="item" @click="toItem('bs','血糖','bs')">
            <div class="hd">
              <i class="iconfont icon-xuetang" />
              血糖</div>
            <div class="bd">
              <div v-if="health.firstBloodSugar.state">{{ health.firstBloodSugar.bs }}<span class="key">mmol/L</span>
                <i v-if="strChangeArr(health.firstBloodSugar.state2)[0]==='偏高'" class="iconfont icon-iconset0414 abnormal" />
                <i v-if="strChangeArr(health.firstBloodSugar.state2)[0]==='偏低'" class="iconfont icon-xiajiantou abnormal" />
                <span v-if="strChangeArr(health.firstBloodSugar.state2)[0]==='正常'" class="abnormal-mr" />
              </div>
              <div v-else class="key">未测量</div>
              <div v-if="health.firstBloodSugar && health.firstBloodSugar.state && health.firstBloodSugar.testTime!=null && health.firstBloodSugar.testTime !==''" class="time">
                {{ dateFormat(health.firstBloodSugar.testTime, 'YYYY-MM-DD hh:mm') }}
              </div>
            </div>
          </div>

          <div class="item" @click="toItem('hr','心率','hb')">
            <div class="hd">
              <i class="iconfont icon-xinshuai" />
              心率</div>
            <div class="bd">
              <div v-if="health.firstHeartBeat.state">{{ health.firstHeartBeat.hb }}<span class="key">bpm</span>
                <i v-if="strChangeArr(health.firstHeartBeat.state2)[0]==='偏高'" class="iconfont icon-iconset0414 abnormal" />
                <i v-if="strChangeArr(health.firstHeartBeat.state2)[0]==='偏低'" class="iconfont icon-xiajiantou abnormal" />
                <span v-if="strChangeArr(health.firstHeartBeat.state2)[0]==='正常'" class="abnormal-mr" />
              </div>
              <div v-else class="key">未测量</div>
              <div v-if="health.firstHeartBeat && health.firstHeartBeat.state && health.firstHeartBeat.testTime!=null && health.firstHeartBeat.testTime !==''" class="time">
                {{ dateFormat(health.firstHeartBeat.testTime, 'YYYY-MM-DD hh:mm') }}
              </div>
            </div>
          </div>
          <!-- 专业心电 -->
          <div v-if="!health.firstHeartState.state2" class="item" @click="toItem('hbtEcg')">
            <div class="hd">
              <i class="iconfont icon-xinlv" />
              心电</div>
            <div class="bd">
              <div v-if="health.firstEcg.analysisResults">{{ health.firstEcg.analysisResults }}<span class="key" />
                <span class="abnormal-mr" />
              </div>
              <div v-else class="key">未测量</div>
              <div v-if="health.firstEcg && health.firstEcg.analysisResults && health.firstEcg.testTime!=null && health.firstEcg.testTime !==''" class="time">
                {{ dateFormat(health.firstEcg.testTime, 'YYYY-MM-DD hh:mm') }}
              </div>
            </div>
          </div>
          <!-- 普通心电 -->
          <div v-if="health.firstHeartState.state2" class="item" @click="toItem('hbt')">
            <div class="hd">
              <i class="iconfont icon-xinlv" />
              心电</div>
            <div class="bd">
              <div v-if="health.firstHeartState.state2">{{ strChangeArr(health.firstHeartState.state2)[3] }}<span class="key" />
                <i v-if="strChangeArr(health.firstHeartState.state2)[3]!=='正常'" class="iconfont icon-iconset0414 abnormal" />
                <span v-else class="abnormal-mr" />
              </div>
              <div v-else class="key">未测量</div>
              <div v-if="health.firstHeartState && health.firstHeartState.state && health.firstHeartState.testTime!=null && health.firstHeartState.testTime !==''" class="time">
                {{ dateFormat(health.firstHeartState.testTime, 'YYYY-MM-DD hh:mm') }}
              </div>
            </div>
          </div>

          <div class="item" @click="toItem('heartLoad','心脏负荷','heartLoadAvg')">
            <div class="hd">
              <i class="iconfont icon-yali" />
              心脏负荷</div>
            <div class="bd">
              <div v-if="health.heartLoadDaily.state">{{ health.heartLoadDaily.heartLoadAvg }}<span class="key">pi</span>
                <i v-if="!health.heartLoadDaily.normal" class="iconfont icon-iconset0414 abnormal" />
                <span v-if="health.heartLoadDaily.normal" class="abnormal-mr" />
              </div>
              <div v-else class="key">未测量</div>
              <div v-if="health.heartLoadDaily && health.heartLoadDaily.state && health.heartLoadDaily.testTime!=null && health.heartLoadDaily.testTime !==''" class="time">
                {{ dateFormat(health.heartLoadDaily.testTime, 'YYYY-MM-DD hh:mm') }}
              </div>
            </div>
          </div>

          <div class="item" @click="toItem('bo','血氧','bo')">
            <div class="hd">
              <i class="iconfont icon-bo" />
              血氧</div>
            <div class="bd">
              <div v-if="health.firstBloodOxygen.state">{{ health.firstBloodOxygen.bo }}<span class="key">%</span>
                <i v-if="strChangeArr(health.firstBloodOxygen.state2)[0]==='偏高'" class="iconfont icon-iconset0414 abnormal" />
                <i v-if="strChangeArr(health.firstBloodOxygen.state2)[0]==='偏低'" class="iconfont icon-xiajiantou abnormal" />
                <span v-if="strChangeArr(health.firstBloodOxygen.state2)[0]==='正常'" class="abnormal-mr" />
              </div>
              <div v-else class="key">未测量</div>
              <div v-if="health.firstBloodOxygen && health.firstBloodOxygen.state && health.firstBloodOxygen.testTime!=null && health.firstBloodOxygen.testTime !==''" class="time">
                {{ dateFormat(health.firstBloodOxygen.testTime, 'YYYY-MM-DD hh:mm') }}
              </div>
            </div>
          </div>
          <div>
            <div v-if="health.firstArteriosclerosis.api>0&& health.firstArteriosclerosis.avi" class="item" @click="toItem('avi','动脉硬化指数','avi&api')">
              <div class="hd">
                <i class="iconfont icon-icondmyh" />
                动脉硬化指数</div>
              <div class="bd">
                <div v-if="health.firstArteriosclerosis.state">
                  <span v-if=" health.firstArteriosclerosis.asi!==0" :class="strChangeArr(health.firstArteriosclerosis.state2)[0]!=='正常'?'abnormal':''">{{ health.firstArteriosclerosis.asi }}</span>
                  <span v-else><span :class="strChangeArr(health.firstArteriosclerosis.state2)[0]!=='正常'?'abnormal':''">{{ health.firstArteriosclerosis.api }}</span>/<span :class="strChangeArr(health.firstArteriosclerosis.state2)[1]!=='正常'?'abnormal':''">{{ health.firstArteriosclerosis.avi }}</span></span><span class="key">mL/mmHg</span>
                  <i v-if="!health.firstArteriosclerosis.normal" class="iconfont icon-iconset0414 abnormal" />
                  <span v-if="health.firstArteriosclerosis.normal" class="abnormal-mr" />
                </div>
                <div v-else class="key">未测量</div>
                <div v-if="health.firstArteriosclerosis && health.firstArteriosclerosis.state && health.firstArteriosclerosis.testTime!=null && health.firstArteriosclerosis.testTime !==''" class="time">
                  {{ dateFormat(health.firstArteriosclerosis.testTime, 'YYYY-MM-DD hh:mm') }}
                </div>
              </div>
            </div>
            <div v-else class="item" @click="toItem('asi','动脉硬化指数','asi')">
              <div class="hd">
                <i class="iconfont icon-icondmyh" />
                动脉硬化指数</div>
              <div class="bd">
                <div v-if="health.firstArteriosclerosis.state">
                  <span v-if=" health.firstArteriosclerosis.asi!==0" :class="strChangeArr(health.firstArteriosclerosis.state2)[0]!=='正常'?'abnormal':''">{{ health.firstArteriosclerosis.asi }}</span>
                  <span v-else><span :class="strChangeArr(health.firstArteriosclerosis.state2)[0]!=='正常'?'abnormal':''">{{ health.firstArteriosclerosis.api }}</span>/<span :class="strChangeArr(health.firstArteriosclerosis.state2)[1]!=='正常'?'abnormal':''">{{ health.firstArteriosclerosis.avi }}</span></span><span class="key">mL/mmHg</span>
                  <i v-if="!health.firstArteriosclerosis.normal" class="iconfont icon-iconset0414 abnormal" />
                  <span v-if="health.firstArteriosclerosis.normal" class="abnormal-mr" />
                </div>
                <div v-else class="key">未测量</div>
                <div v-if="health.firstArteriosclerosis && health.firstArteriosclerosis.state && health.firstArteriosclerosis.testTime!=null && health.firstArteriosclerosis.testTime !==''" class="time">
                  {{ dateFormat(health.firstArteriosclerosis.testTime, 'YYYY-MM-DD hh:mm') }}
                </div>
              </div>
            </div>
          </div>
          <div class="item" @click="toItem('measure','BMI')">
            <div class="hd">
              <i class="iconfont icon-bmi" />
              BMI</div>
            <div class="bd">
              <div v-if="health.firstBMI">{{ health.firstBMI }}<span class="key" /></div>
              <div v-else class="key">未测量</div>
            </div>
          </div>
          <div class="item" @click="toItem('step')">
            <div class="hd">
              <i class="iconfont icon-paobu" />
              运动</div>
            <div class="bd">
              <div v-if="health.firstWalkStep && health.firstWalkStep.step!=null && health.firstWalkStep.step !==''">{{ health.firstWalkStep.step }}<span class="key">步</span></div>
              <div v-else class="key">未测量</div>
              <div v-if="health.firstWalkStep && health.firstWalkStep.testTime!=null && health.firstWalkStep.testTime !==''" class="time">
                {{ dateFormat(health.firstWalkStep.testTime, 'YYYY-MM-DD hh:mm') }}
              </div>
            </div>
          </div>
          <div class="item" @click="toItem('audio')">
            <div class="hd">
              <i class="iconfont icon-yinpin" />
              脏音</div>
            <div class="bd">
              <div v-if="health.firstStethoScope.audioUrl" class="sy-cell_flexEnd">
                <audio ref="audios" :src="health.firstStethoScope.audioUrl" />
                <van-slider v-if="palyA" v-model="durationVal" disabled class="audio-slider" active-color="#FCA251" />
                <van-icon v-show="!palyA" name="play-circle-o" @click.stop="playAudio" />
                <van-icon v-show="palyA" name="pause-circle-o" @click.stop="suspendAudio" />
              </div>
              <div v-else class="key">未测量</div>
              <div v-if="health.firstStethoScope && health.firstStethoScope.audioUrl && health.firstStethoScope.testTime!=null && health.firstStethoScope.testTime !==''" class="time">
                {{ dateFormat(health.firstStethoScope.testTime, 'YYYY-MM-DD hh:mm') }}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <van-loading v-if="loadings" color="#F18937" vertical />
  </van-pull-refresh>
</template>

<script>
require('echarts/lib/chart/line')
import addFamily from '@/assets/images/home/addFamily.png'
import defaultImg from '@/assets/images/family/default.png'
import { getUserInfosByAccountId, createUserGroup, minusGroupFamily, getRequestUnhandleCnt } from '@/api/family'
import { fetchHealthFirst } from '@/api/health'
import { setUserGroupId, getUserGroupId, setAccountId, setToken } from '@/utils/auth'

import { dateFormat, strChangeArr } from '@/utils/tool'
export default {

  data() {
    return {
      applycount: 0,
      showFam: false,
      defaultImg,
      userGroupId: '',
      familyList: [
      ],
      groupData: {
        accountId: 0,
        mac: 'varcharUser'
      },
      isRefreshing: false,
      palyA: false,
      timer: null,
      durationVal: 0,
      quesstionReslute: true,
      dateFormat,
      strChangeArr,
      addFamily,
      active: 0,
      loadings: false,
      health: {
        step: {},
        bp: {},
        bs: {},
        sleep: {},
        firstHrv: {},
        apnea: {},
        heartLoadDaily: {},
        firstSleepActivity: {},
        firstBloodPressure: {},
        firstBloodOxygen: {},
        firstHeartBeat: {},
        firstBloodSugar: {},
        firstHeartState: {},
        firstArteriosclerosis: {},
        firstWalkStep: {},
        firstStethoScope: {},
        firstEcg: {}
      },
      myChart: null,
      errorImg: '',
      minus: true,
      userGroupAccountId: '',
      userRelationship: ''
    }
  },
  created() {
    this.groupData.accountId = this.$route.query.accountId
    var token = this.$route.query.token// Base64，不然会报错
    const Base64 = require('js-base64').Base64// 还是require
    var tokenNow = Base64.encode(this.$route.query.accountId)
    if (token === tokenNow) {
      setToken(token)
      setAccountId(this.$route.query.accountId)
    } else {
      this.$toast('token 错误')
      setAccountId(0)
    }
    // this.getData()
    this.getFamilyList()
    this.getRequestUnhandleCnt()
    // this.getScore()
    // this.getQueReslut()
  },
  methods: {
    getData(accountId) {
      fetchHealthFirst({ accountId: accountId }).then(res => {
        this.loadings = false
        res.data.data.firstBloodPressure = res.data.data.firstBloodPressure ? res.data.data.firstBloodPressure : {}
        res.data.data.apnea = res.data.data.apnea ? res.data.data.apnea : {}
        res.data.data.heartLoadDaily = res.data.data.heartLoadDaily ? res.data.data.heartLoadDaily : {}
        res.data.data.firstHrv = res.data.data.firstHrv ? res.data.data.firstHrv : {}
        res.data.data.firstSleepActivity = res.data.data.firstSleepActivity ? res.data.data.firstSleepActivity : {}
        res.data.data.firstHeartState = res.data.data.firstHeartState ? res.data.data.firstHeartState : {}
        res.data.data.firstBloodOxygen = res.data.data.firstBloodOxygen ? res.data.data.firstBloodOxygen : {}
        res.data.data.firstHeartBeat = res.data.data.firstHeartBeat ? res.data.data.firstHeartBeat : {}
        res.data.data.firstBloodSugar = res.data.data.firstBloodSugar ? res.data.data.firstBloodSugar : {}
        res.data.data.firstWalkStep = res.data.data.firstWalkStep ? res.data.data.firstWalkStep : null
        res.data.data.firstArteriosclerosis = res.data.data.firstArteriosclerosis ? res.data.data.firstArteriosclerosis : {}
        res.data.data.firstBMI = res.data.data.firstBMI ? res.data.data.firstBMI : null
        res.data.data.firstStethoScope = res.data.data.firstStethoScope ? res.data.data.firstStethoScope : {}
        res.data.data.firstEcg = res.data.data.firstEcg ? res.data.data.firstEcg : {}
        this.health = res.data.data
      }).catch(error => {
        console.log(error)
      })
    },
    onRefresh() {
      setTimeout(() => {
        this.isRefreshing = false
        // this.getData()
        // this.getFamilyList()
        this.getFamilyList()
        this.getRequestUnhandleCnt()
      }, 500)
    },
    beforeClose() {
      if (!this.loadings) {
        minusGroupFamily({
          accountId: this.userGroupAccountId,
          userGroupId: this.userGroupId
        }).then(res => {
          this.$toast('删除成功')
          this.getFamilyList()
        }).catch(error => {
          console.log(error)
          this.$toast('删除失败')
        })
      }
    },
    queryToFamilyById(accountId, index, name) {
      if (!this.loadings) {
        this.userGroupAccountId = accountId
        this.familyList.forEach((item, itenIndex) => {
          if (index === itenIndex) {
            this.$set(item, 'select', true)
            this.userRelationship = item.relationShip
          } else {
            this.$set(item, 'select', false)
          }
        })
        console.log(this.userRelationship)
        this.loadings = true
        this.getData(accountId)
      }
    },
    getFamilyList() {
      var this_ = this
      getUserInfosByAccountId().then(res => {
        console.log(res)
        if (res.data.data === null || res.data.data.length === 0) {
          this.userGroupAccountId = null
          this.userRelationship = null
          this_.showFam = true
          createUserGroup(this_.groupData).then(res => {
            this_.userGroupId = res.data.data.userGroupId
            setUserGroupId(this_.userGroupId)
          }).catch(error => {
            console.log(error)
          })
        } else {
          var familyList = res.data.data.userInfos
          this_.userGroupId = res.data.data.userGroupId
          setUserGroupId(this_.userGroupId)
          var resultArr = []
          familyList.forEach(function(item, i) {
            console.log(item)
            var currAccountId = this_.groupData.accountId
            if (item.accountId !== parseInt(currAccountId)) {
              if (!item.headUrl) {
                item.headUrl = defaultImg
              }
              resultArr.push(item)
            }
            this_.health = {
              step: {},
              bp: {},
              bs: {},
              sleep: {},
              firstHrv: {},
              apnea: {},
              heartLoadDaily: {},
              firstSleepActivity: {},
              firstBloodPressure: {},
              firstBloodOxygen: {},
              firstHeartBeat: {},
              firstBloodSugar: {},
              firstHeartState: {},
              firstArteriosclerosis: {},
              firstWalkStep: {},
              firstStethoScope: {},
              firstEcg: {}
            }
          })
          this_.familyList = resultArr

          if (resultArr.length > 0) {
            this_.showFam = false
            // this.userGroupAccountId = this_.familyList[0].accountId
            // this.userRelationship = this_.familyList[0].relationShip
            this_.queryToFamilyById(this_.familyList[0].accountId, 0)
          } else {
            this_.showFam = true
          }
        }
      }).catch(error => {
        console.log(error)
      })
    },
    toAddFamily() {
      if (getUserGroupId()) {
        this.$router.push(`/familyApp/add/nav`)
      } else {
        this.getFamilyList()
      }
    },
    toEditPeople() {
      if (this.userGroupAccountId) {
        this.$router.push({ path: `/family/add`, query: { peopleAccountId: this.userGroupAccountId, peopleRelationship: this.userRelationship }})
      } else {
        this.$toast('您没有可以编辑的家人')
      }
    },
    toApplyList() {
      this.$router.push({ path: `/family/applyList`, query: { }})
    },
    // 删除
    minusFamily() {
      this.minus = false
    },
    toItem(name, title, fields) {
      if (!fields) {
        if (!title) {
          this.$router.push(`/health/${name}`)
        }
      } else {
        this.$router.push({
          path: '/health/measure',
          query: { urls: `/api/v1/${name}/user/static`, names: title, field: fields, peopleAccountId: this.userGroupAccountId }
        })
      }
    },
    playAudio() {
      var audios = this.$refs.audios
      this.durationVal = 0
      console.log(audios.duration)

      if (audios.play()) {
        this.palyA = true
        audios.play()
        this.timer = setInterval(() => {
          this.durationVal = audios.currentTime / audios.duration * 100
          if (this.durationVal >= 99) {
            clearInterval(this.timer)
            this.palyA = false
          }
        }, 1000)
      }
    },
    suspendAudio() {
      this.palyA = false
      clearInterval(this.timer)
      this.$refs.audios.pause()
      this.$refs.audios.load()
    },
    getRequestUnhandleCnt() {
      var this_ = this
      getRequestUnhandleCnt().then(res => {
        if (res.data.code === 0) {
          this_.applycount = res.data.data
        }
      }).catch(error => {
        console.log(error)
      })
    }
  }
}
</script>

<style scoped lang="scss">
  .home-hd {
    padding: 40px 11px 0;
    margin-bottom: 15px;
    /*background-image: linear-gradient(to bottom, #FFCA30 0,#F9F8F8 20% )*/
  }

  .score {
    /*padding: 15px 0;*/
    margin-top: 15px;
    background: #fff;
    border-radius: 15px;
    .van-grid{
      min-height:116px;
      padding-top:13px;
      .ibox-main{
        width:18%;
        // height:73px;
        margin-right:1%;
        margin-top:7px;
        margin-bottom:20px;
        margin-left:1%;
        flex-direction: column;
        position:relative;
      }
      .main-top{
        margin-top:14px;
      }
      .radio-no{
        width:14px;
        height:14px;
        position: absolute;
        background:#fff;
        border-radius:50%;
        border:1px solid #ACACAC;
        top: 0;
        right:0;
        .van-icon{
          top:-3px;
          color:#fff;
          font-size: 12px;
        }
      }
      .radio-check{
         border:1px solid #F18A2E;
         background: #F18A2E;
      }
    }
    .hd {
      font-size: 12px;
      color: #666;
    }
    .bd {
      width: 160px;
      height: 160px;
      margin: 10px auto 0;
      border-radius: 50%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background: url('../../assets/images/home/score-bg.png');
      background-size: cover;
    }
    .key {
      color: #666;
      font-size: 12px;
    }
    .val {
      color: #7E3C00;
      font-size: 28px;
      line-height: 1.3;
      font-weight: bold;
    }
  }

  .analysis, .sport {
    .iconfont {
      font-size: 20px;
      color: #999;
      vertical-align: -2px;
      margin-right: 5px;
    }
    .title {
      font-size: 14px;
      color: #999;
      margin: 15px 0 5px;
    }
    .abnormal {
      margin: 0;
      color: red;
    }
  }

  .analysis {
    position: relative;
    .bd {
      height: 180px;
      background: #fff;
      border-radius: 5px;
    }
    .empty {
      text-align: center;
      color: #999;
      font-size: 12px;
      width: 100%;
      position: absolute;
      top: 45%;
    }
  }

  .sport {
    .content {
      background: #fff;
      padding: 0 15px;
      border-radius: 5px;
    }
    .item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 15px 0;
      border-bottom: 1px solid #ececec;
    }
   .item:nth-last-child(1) {
      border: none;
    }
    // .itemborder{
    //   border-bottom: 1px solid #ececec;
    // }
    .hd {
      font-size: 16px;
    }
    .bd {
      text-align: right;
      font-size: 24px;
    }
    .key {
      font-size: 12px;
      font-weight: normal;
      color: #999;
      margin-left: 5px;
    }
    .time {
      color: #999;
      font-size: 12px;
      font-weight: normal;
    }
  }

  .reports {
    margin: 15px 0 5px;
    display: flex;
    flex-wrap: wrap;
    .report {
      font-size: 14px;
      background: #fff;
      border-radius: 5px;
      width: 48%;
      margin-bottom: 10px;
      padding: 15px;
      display: flex;
      align-items: center;
      img {
        width: 38px;
        display: block;
        margin-right: 15px;
      }
    }
    .report:nth-child(odd) {
      margin-right: 4%;
    }
  }

  .informations {
    padding: 0 15px;
    background: #fff;
  }

  .information {
    padding: 15px 0;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #ececec;
    .hd {
      width: 30%;
      height: 80px;
      background-size: cover;
      background-position: center;
      .img {
        height: 80px;
      }
    }
    .bd {
      flex: 1;
      padding-left: 15px;
    }
    .time {
      font-size: 12px;
      color: #999;
      margin-top: 5px;
    }
  }

  audio {
    width: 200px;
    height: 30px;
  }

  .audio-slider {
    width: 80px;
    margin-right: 30px;
    /deep/ .van-slider__button {
      width: 10px;
      height: 10px;
    }

  }

  .score-box_par {
    padding: 0 5px;
  }

  .score-box {
    width: 20%;
    margin-top: 15px;
    text-align: center;
    color: #999;
    line-height: 24px;
    font-size: 12px;
    position: relative;
    &::after {
      content: '';
      width: 1px;
      height: 30px;
      background: #f1f1f1;
      display: block;
      position: absolute;
      top: 8px;
      right: 0;
    }
    &:last-child::after {
      display: none;
    }
  }

  .waring-tag {
    position: absolute;
    top: -29px;
    left: 0px;
    width: 60px;
    display: inline-block;
    background: #F88E00;
  }

  .d3 {
    position: absolute;
    top: -10px;
    left: 25px;
    width: 0;
    height: 0;
    border-width: 5px;
    border-style: solid;
    border-color: #F88E00 transparent transparent transparent;
  }

  .peo-image__img {
    display: block;
    width: 49px;
    height: 49px;
    border-radius: 50%;
    object-fit: cover;
  }

  .describe {
    margin-top:5px;
    text-align: center;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width:48px;
  }
  .describe-color {
    color: #F18A2E;
  }

  /deep/ .van-grid-item__content--center {
    border-radius: 15px;
  }
  .addfamily{
    display: block;
    height: 40px;
    width: 40px;
  }
  .divs{
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 30px 0px;
    .imgs{
      display: inline-block;
      vertical-align: middle;
      margin-right: 10px;
    }
    .infos{
      display: inline-block;
      color: #F18A2E;font-size:20px
    }
  }
.headerActive{
  border:2px solid #F18A2E;
  border-radius: 50%;
}
.headerNo{
   border:2px solid #fff;
   border-radius: 50%;
   box-sizing: border-box;
   width:49px;
}
/deep/.van-loading--vertical{
    position: fixed;
    top: 48%;
    left: 44%;
}
.del-btn{
  width:54px;
  height:27px;
  border-radius:5px;
  border:1px solid rgba(241,138,46,1);
  background:#F18A2E;
  color:#FFFFFF;
  font-size: 13px;
}
.cancle-btn{
  color:#F18A2E;
  background:#fff;
}
</style>
